(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('MyIDDetailController', MyIDDetailController);

    MyIDDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'MyID', 'Customer'];

    function MyIDDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, MyID, Customer) {
        var vm = this;

        vm.myID = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:myIDUpdate', function(event, result) {
            vm.myID = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
